import { RobotHappyOutlineIcon } from './RobotHappyOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 62023A79-6DF7-4B3B-BDCA-FEEAE73C9F89
 * name robot-happy-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-happy-outline.svg
 * tags
 */
export const EmojiRobotHappyOutlineIcon = RobotHappyOutlineIcon;
export default EmojiRobotHappyOutlineIcon